import { useSessionWarning } from './sessionWarningContext';
import SessionTimeoutWarning from './SessionTimeoutWarning';

/**
 * Renders the idle-timeout warning from AuthProvider's session-warning state.
 * MUST live inside LocaleProvider (the dialog needs intl) — AuthProvider itself
 * sits above it in App.js, which is why this host exists. Mounted by
 * SessionScopedShell while signed in (every role incl. platform).
 */
export default function SessionTimeoutWarningHost() {
  const w = useSessionWarning();
  if (!w?.show) return null;
  return (
    <SessionTimeoutWarning
      getRemainingMs={w.getRemainingMs}
      getLastActivityAt={w.getLastActivityAt}
      onStay={w.onStay}
      onSignOutNow={w.onSignOutNow}
      expired={w.expired}
      onExpiredDone={w.onExpiredDone}
    />
  );
}
